import { createFileRoute, Outlet, Link, useLocation } from '@tanstack/react-router'
import authClient from '#/auth/authClient'
import { useOrganization } from '#/lib/queries'
import { Settings, Home, UserCheck, FileText, Filter } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$slug/settings')({
  component: SettingsLayout,
})

function SettingsLayout() {
  const { slug } = Route.useParams()
  const location = useLocation()
  const { data: session } = authClient.useSession()
  const { data: organization } = useOrganization(slug)

  const member = organization?.members?.find(
    (m: any) => m.userId === session?.user?.id
  )

  const getActiveTab = () => {
    const path = location.pathname
    if (path.includes('/settings/templates')) return 'templates'
    if (path.includes('/settings/segments')) return 'segments'
    // users tab moved to Account UI
    if (path.includes('/settings/contacts')) return 'contacts'
    if (path.includes('/settings/properties')) return 'properties'
    return 'settings'
  }

  const isOwnerOrAdmin = member?.role === 'owner' || member?.role === 'admin'

  if (!organization) return null

  const tabClass = (tab: string) =>
    `flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 transition-colors ${
      getActiveTab() === tab
        ? 'border-primary text-foreground'
        : 'border-transparent text-muted-foreground hover:text-foreground'
    }`

  return (
    <div className="flex-1 flex flex-col">
      <div className="bg-background">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex gap-4 border-b -mb-[1px]">
            <Link to="/$slug/settings/contacts" params={{ slug }} className={tabClass('contacts')}>
              <UserCheck className="h-4 w-4" /> Contacts
            </Link>
            <Link to="/$slug/settings/properties" params={{ slug }} className={tabClass('properties')}>
              <Home className="h-4 w-4" /> Properties
            </Link>
            {isOwnerOrAdmin && (
              <Link to="/$slug/settings/templates" params={{ slug }} className={tabClass('templates')}>
                <FileText className="h-4 w-4" /> Templates
              </Link>
            )}
            {isOwnerOrAdmin && (
              <Link to="/$slug/settings/segments" params={{ slug }} className={tabClass('segments')}>
                <Filter className="h-4 w-4" /> Segments
              </Link>
            )}
            {isOwnerOrAdmin && (
              <Link to="/$slug/settings/organization" params={{ slug }} className={tabClass('settings')}>
                <Settings className="h-4 w-4" /> Organization
              </Link>
            )}
          </nav>
        </div>
      </div>
      <div className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 lg:pb-8">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
